import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },

  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  contentWrapper: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2, 5),
    display: 'flex',
    justifyContent: 'space-between',
  },
  headingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  downloadButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  listingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  filterSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  filtersContainer: { display: 'flex', justifyContent: 'space-between' },
  labelContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelContentTitle: {
    alignSelf: 'center',
    color: theme.palette.shadows.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  labelSubTitle: {
    color: theme.palette.shadows.light,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  dateRangePickerWrrapper: {
    width: theme.spacing(27.875),
    '& .MuiOutlinedInput-adornedEnd': {
      background: 'none',
    },
  },
  dateRangePickerHeader: {
    width: 'auto',
    height: theme.spacing(5.5),
    '& .MuiInputBase-input': {
      fontSize: '12px',
    },
  },
  filtersAppliedContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(-2),
  },
  filters: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '370px',
  },
}))
